import { IFederalLottery } from '../../../interfaces';
import privateHttpClient from '../privateHttpClient';
import { urlHttpGov } from '../../urls';
import FederalLotteryMapper from '../mappers/FederalLotteryMapper';

class LotteryFederalService {
    private baseURL: string = `${urlHttpGov}/panel/federal-lottery-raffle`;


    async getFederalLotteryByDate(date: string, signal: AbortSignal): Promise<IFederalLottery> {
        const { data } = await privateHttpClient.get(`${this.baseURL}/${date}`,
            {
                signal,
            });

        return FederalLotteryMapper.toDomain(data);
    }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new LotteryFederalService();
